import { useBuildQueryParams } from '../../lib/hooks/useBuildQueryParams'
import { useBuildSortingParams } from '../../lib/hooks/useBuildSortingParams'
import { useQuery } from 'react-query'
import request from '../request'

export const useGetInventoryDataProviders = ({
  pageIndex,
  pageSize,
  filters,
  sorting,
}: {
  pageIndex?: number
  pageSize?: number
  filters?: Record<string, any>
  sorting?: Array<Record<string, any>>
}) => {
  const queryParams = useBuildQueryParams(filters)
  const sortingParams = useBuildSortingParams(sorting)
  return useQuery<Record<string, any>>(
    ['inventory', 'data_providers', { pageIndex, pageSize, queryParams, sortingParams }],
    ({ signal }) =>
      request({
        url: '/admin/inventory_data_providers',
        params: {
          pageIndex,
          pageSize,
          ...queryParams,
          sorting: sortingParams,
        },
        signal,
      }),
    { keepPreviousData: true },
  )
}
